module.exports = __webpack_public_path__ + "img/girl_001.eb5b989d.jpg";